import { render, staticRenderFns } from "./ODownloadFileButton.vue?vue&type=template&id=1770cddc&scoped=true&"
import script from "./ODownloadFileButton.vue?vue&type=script&lang=js&"
export * from "./ODownloadFileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770cddc",
  null
  
)

export default component.exports